import React, { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import Navigation from './src/navigation/Navigation';
import { PopupProvider } from './src/contexts/PopupContext';
import { ThemeProvider, useTheme } from './src/contexts/ThemeContext';
import './src/styles/global.css';
import { applyGlobalStyles } from './src/utils/styleUtils';
import { installMobileKeyboardFocus } from './src/utils/mobileKeyboardFocus';

function AppContent() {
  const { theme, isDarkMode } = useTheme();
  
  useEffect(() => {
    applyGlobalStyles();
    return installMobileKeyboardFocus();
  }, []);

  return (
    <PopupProvider>
      <View style={[styles.container, { backgroundColor: isDarkMode ? theme.background.primary : '#000000' }]}>
        <Navigation />
      </View>
    </PopupProvider>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    position: 'relative',
    overflow: 'hidden',
  },
});


